module.exports = __webpack_public_path__ + "img/icon-estatus-de-factura.c39712c4.svg";